import React, { Component } from 'react';
import {FormattedMessage, injectIntl} from "react-intl";
import cls from './InputWindow.module.scss';

import Button from 'Flow2/components/UI/Button/Button';
import Input from 'Flow2/components/UI/Input/Input';
import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';

const InputWindow = (props) => {
    return (
        <div onClick={props.onCancel} className={[cls.InputWindow, cls.Overlay, cls[props.show]].join(' ')}>
            <div className={[cls.Window].join(' ')} onClick={(evt) => {evt.stopPropagation();}}>
                <h3>{ props.title }</h3>
                { props.content }
                <FlexRow>
                    <Button
                        key="ok"
                        btnType="Red"
                        clicked={props.onSave}>
                        <FormattedMessage id="common.ok" />
                    </Button>
                    <Button
                        key="cancel"
                        btnType="White"
                        clicked={props.onCancel}>
                        <FormattedMessage id="common.cancel" />
                    </Button>
                </FlexRow>
            </div>
        </div>
    );
}

export default InputWindow;
